<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers />
			</el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!--Header-->
							<div class="page_header">Add/Edit Root Cause</div>
							<!--Header-->
							<div class="page_main">
								<el-form ref="form" :model="info" label-position="top" class="request-form">
									<el-form-item label="CAPA ID" class="full-width-item">
										<div class="gray-input">
											{{ info.request_id || "/" }}
										</div>
									</el-form-item>
									<div class="form-grid">
										<!-- Left -->
										<div class="form-col">
											<el-form-item label="Status">
												<div class="gray-input">
													{{ info.status_name }}
												</div>
											</el-form-item>
											<el-form-item label="Priority">
												<div class="gray-input">
													{{ info.priority }}
												</div>
											</el-form-item>
											<el-form-item label="Investigator">
												<div class="gray-input">
													{{ info.investigator }}
												</div>
											</el-form-item>
										</div>
										<!-- Right -->
										<div class="form-col">
											<el-form-item label="Request Date">
												<div class="gray-input">
													{{ info.time1 || "/" }}
												</div>
											</el-form-item>
											<el-form-item label="Acceptance Date">
												<div class="gray-input">
													{{ info.time2 || "/" }}
												</div>
											</el-form-item>
											<el-form-item label="Investigation Start Date">
												<div class="gray-input">
													{{ info.time3 || "/" }}
												</div>
											</el-form-item>
										</div>
									</div>
									<div class="text-tip">CAPA Description</div>
									<el-form-item label="Description of the Problem, Concern, Idea, or Opportunity" class="full-width-item">
										<div class="gray-input">
											{{ info.description || "/" }}
										</div>
									</el-form-item>
									<div class="tip-box">
										Use the "Root Cause Analysis Result" field to describe the root cause identified by the analysis and indicate any other departments, equipment, or production outputs that may be affected.
									</div>
									<!-- Description input -->
									<div class="form-item full">
										<div class="label">
											Root Cause Analysis Result<span class="required">*</span>
										</div>
										<el-input v-model="description" type="textarea" :rows="5" resize="vertical" placeholder="" />
									</div>
									<div class="tip-box">
										Please indicate whether this root cause is related to a specific supplier.
									</div>
									<el-form-item label="Is this Root Cause Related to a Supplier?" required>
										<el-select v-model="isSupplierRelated" placeholder="Please Select"
											style="width: 100%" @change="handleSupplierRelatedChange">
											<el-option label="Yes" :value="1" />
											<el-option label="No" :value="2" />
										</el-select>
									</el-form-item>

									<el-form-item v-if="isSupplierRelated == 1" label="Root Cause Supplier" required>
										<el-select v-model="supplierId" placeholder="Please Select a Supplier" style="width: 100%"
											filterable clearable>
											<el-option v-for="item in supplierOptions" :key="item.id" :label="item.title" :value="item.id" />
										</el-select>
									</el-form-item>
									<div class="file-panel">
										<div class="panel-header">
											<div class="table-title">Root Cause Analysis Result Files</div>
										</div>
										<el-table :data="rootCaseData" border stripe header-cell-class-name="table-header-cell" class="file-table" empty-text="No Data">
											<el-table-column prop="" label="Description" sortable min-width="200">
												<template slot-scope="scope">
													<div>{{ scope.row.description || "/" }}</div>
												</template>
											</el-table-column>
											<el-table-column prop="fileName" label="File Name" min-width="240">
												<template slot-scope="scope">
													<a :href="scope.row.url" target="_blank">{{ scope.row.name }}</a>
												</template>
											</el-table-column>
											<el-table-column prop="id" label="Actions" width="80" align="center">
												<template #default="scope">
													<div class="inline_btn">
														<el-button type="danger" size="mini"
															@click="handleRemove(scope.row)">
															Delete
														</el-button>
													</div>
												</template>
											</el-table-column>
										</el-table>
										<el-button type="primary" size="mini" style="margin: 10px"
											@click="handleRootCaseFile">
											Add Root Cause Analysis Result File
										</el-button>
									</div>
								</el-form>
								<!-- Bottom buttons -->
								<div class="footer-actions">
									<el-button type="primary" size="small" @click="handleSave">
										Save
									</el-button>
									<el-button type="primary" size="small" @click="handleCancel">
										Cancel
									</el-button>
								</div>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--Add file dialog-->
		<el-dialog title="Add Root Cause Analysis Result File" :visible.sync="dialogVisible" width="50%">
			<div class="save_box">
				<div class="form_box">
					<div style="padding-bottom: 20px; font-weight: bold; font-size: 16px">
						Please Complete the Following Information
					</div>
					<el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-position="top" class="upload-form">
						<!-- Description -->
						<el-form-item label="Description" prop="description">
							<el-input v-model="ruleForm.description" type="textarea" :rows="5" resize="none"
								placeholder="Please Enter a Description" />
						</el-form-item>
						<!-- Attachment -->
						<el-form-item prop="">
							<div class="upload-doc-wrapper">
								<div class="upload-title required-title">
									<span> File to Upload </span>
									<span class="upload-limit"> (Max 10 MB) </span>
								</div>
								<div class="upload-box" style="position: relative">
									<el-upload
										ref="uploadBox"
										class="doc-upload"
										action="/"
										name="files"
										:show-file-list="false"
										:before-upload="beforeAvatarUpload"
										:on-change="handleAvatarChange"
										:limit="1"
										:with-credentials="true"
										:auto-upload="false"
									>
										<el-button size="medium" class="select-btn">
											Select File
										</el-button>
									</el-upload>
									<div class="file-name" :class="{ placeholder: !fileName }">
										{{ fileName || "No File Selected" }}
										<span v-if="fileName" style="position: absolute; right: 20px; top: 12px; cursor: pointer;color: #f00;" @click="delFile">Delete</span>
									</div>
								</div>
							</div>
						</el-form-item>
					</el-form>
				</div>
				<div class="btn_box">
					<van-button class="btn_el" type="default" round @click="dialogVisible = false">
						Cancel
					</van-button>
					<van-button class="btn_el" round color="linear-gradient(to right, #7BC1FF, #4886FF)"
						@click="submitForm('ruleForm')">
						Confirm
					</van-button>
				</div>
			</div>
		</el-dialog>
		<!--Add file dialog-->
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading />
			</div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import {
	resourcesApplyDetail
} from "@/api/docManage/changeRequest/index";
import {
	capaRootCauseAdd,
	capaRootCauseDetail,
	capaUploadsRootCauseFile,
	capaUploadsRootCauseFileDel
} from "@/api/capaManage/capaRequest/index";
import { suplierList } from '@/api/capaManage/configCapa/capaManageSuppliers/index';
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
import moment from "moment";
export default {
	components: {
		headers,
		slider,
	},
	data() {
		return {
			isLoading: true,
			dialogVisible: false,
			keyword: "",
			rootCaseData: [],
			fileName: "",
			selectedFile: null,
			info: {},
			supplierOptions: [],
			userToken: localStorage.getItem("userToken"),
			ruleForm: {
				id: "",
				description: "",
				fileUrl: "",
			},
			rules: {
				description: [{
					required: true,
					message: "Please enter a comment",
					trigger: "blur"
				}, ],
			},
			rootCauseId: null,
			description: '',
			isSupplierRelated: '',
			supplierId: ''
		};
	},
	mounted() {
		let that = this;
		if(that.$route.query.id) {
			that.rootCauseId = that.$route.query.id;
		}
		//Request supplier
		suplierList({ title: '', page: 1, page_size: 9999 }).then(res => {
			if(res.code == 200) {
				that.supplierOptions = res.data;
			}
		});
		that.getPageInfo();
		that.isLoading = false;
	},
	methods: {
		//Get page details
		getPageInfo() {
			let that = this;
			resourcesApplyDetail({ id: that.$route.query.oid }).then(res => {
				if(res.code == 200) {
					// console.log(res.data);
					that.info = {
						id: res.data.id,
						request_id: res.data.request_id,
						status_name: res.data.status_name,
						priority: res.data.priority,
						investigator: res.data.investigator,
						description: res.data.description,
						username: res.data.username,
						// company_name: res.data.company_name,
						source_type: res.data.source_type,
						departments_name: res.data.departments_name,
						source_info: res.data.source_info,
						time1: res.data.time1,
						time2: res.data.time2,
						time3: res.data.time3,
					};
					that.investigationLogs = res.data.capaaffected_list;
					if(that.rootCauseId) {
						//获取详情
						capaRootCauseDetail({ id: that.rootCauseId }).then(res2 => {
							if(res2.code == 200) {
								that.rootCauseId = res2.data.id;
								that.description = res2.data.analysis_results;
								that.isSupplierRelated = Number(res2.data.is_supplier);
								that.rootCaseData = res2.data.filelist;
								that.$nextTick(() => {
									that.supplierId = res2.data.supplier_id;
								});
							}
						});
					}
				}
			});
		},
		handleAvatarChange(file, fileList) {
	let that = this;
	if (!file && !fileList) return;
	that.selectedFile = file.raw;
	that.fileName = file.name;
	that.$toast.clear();
},

beforeAvatarUpload(file) {
	let that = this;
	const maxSize = 10 * 1024 * 1024; // 10MB
	const isLt100M = file.size <= maxSize;
	if (!isLt100M) {
		that.$message.error("The uploaded file size cannot exceed 10 MB");
		return false;
	}
	that.$toast.loading({
		duration: 0,
		forbidClick: true
	});
},

// Delete File
delFile() {
	let that = this;
	that.selectedFile = null;
	that.fileName = '';
	that.$refs.uploadBox.clearFiles();
},

initTime(value) {
	return moment(value * 1000).format('YYYY-MM-DD HH:mm:ss');
},

// Add Root Cause Analysis Result File
handleRootCaseFile() {
	let that = this;
	if (!that.description.trim()) {
		that.$message.warning("Please enter the Root Cause Analysis Result");
		return;
	}
	if (!that.isSupplierRelated) {
		that.$message.warning("Please select whether this root cause is related to a supplier");
		return;
	}
	if (that.isSupplierRelated == 1) {
		if (!that.supplierId) {
			that.$message.warning("Please select a supplier");
			return;
		}
	}
	capaRootCauseAdd({
		capa_id: that.info.id,
		analysis_results: that.description,
		is_supplier: that.isSupplierRelated,
		supplier_id: that.supplierId,
		id: that.rootCauseId ? that.rootCauseId : ''
	}).then(res => {
		if (res.code == 200) {
			that.rootCauseId = res.data;
			that.dialogVisible = true;
		}
	});
},

handleSupplierRelatedChange() {},

// Save
handleSave() {
	let that = this;
	if (!that.description.trim()) {
		that.$message.warning("Please enter the Root Cause Analysis Result");
		return;
	}
	if (!that.isSupplierRelated) {
		that.$message.warning("Please select whether this root cause is related to a supplier");
		return;
	}
	if (that.isSupplierRelated == 1) {
		if (!that.supplierId) {
			that.$message.warning("Please select a supplier");
			return;
		}
	}
	that.$toast.loading({
		duration: 0,
		forbidClick: true
	});
	capaRootCauseAdd({
		capa_id: that.info.id,
		analysis_results: that.description,
		is_supplier: that.isSupplierRelated,
		supplier_id: that.supplierId,
		id: that.rootCauseId ? that.rootCauseId : ''
	}).then(res => {
		if (res.code == 200) {
			that.$toast.clear();
			that.$message.success("Operation successful");
			setTimeout(() => {
				window.location.reload();
			}, 800);
		}
	});
},

handleCancel() {
	let that = this;
	that.$router.back();
},

// Upload Root Cause Analysis Result Files
submitForm(formName) {
	let that = this;
	that.$refs[formName].validate((valid) => {
		if (valid) {
			if (!that.selectedFile) {
				that.$message.warning("Please upload a file");
				return false;
			}
			that.$toast.loading({
				duration: 0,
				forbidClick: true
			});
			const formData = new FormData();
			formData.append('files', that.selectedFile);
			formData.append('description', that.ruleForm.description);
			formData.append('capa_id', that.info.id);
			formData.append('root_cause_id', that.rootCauseId);
			formData.append('id', '');
			capaUploadsRootCauseFile(formData).then(res => {
				if (res.code == 200) {
					that.$toast.clear();
					that.$message.success("Operation successful");
					setTimeout(() => {
						window.location.reload();
					}, 800);
				}
			});
		} else {
			return false;
		}
	});
},

// Delete Root Cause Analysis Result File
handleRemove(value) {
	let that = this;
	that.$confirm(
		"Are you sure you want to delete this Root Cause Analysis Result file?",
		"Confirmation",
		{
			type: "warning",
		}
	).then(() => {
		that.$toast.loading({
			duration: 0,
			forbidClick: true
		});
		capaUploadsRootCauseFileDel({
			id: value.id
		}).then((res) => {
			if (res.code == 200) {
				that.$toast.clear();
				that.$message.success("Operation successful");
				setTimeout(() => {
					window.location.reload();
				}, 800);
			}
		});
	}).catch(() => {});
},
		//跳转页面
		goUrl(url) {
			let that = this;
			that.$router.push(url);
		},
	},
};
</script>

<style lang="less" scoped>
	.save_box {
		.btn_box {
			text-align: right;

			.btn_el {
				margin-left: 10px;
				padding: 12px 24px;

				.van-button__text {
					font-size: 16px;
				}
			}
		}

		.form_box {
			.input_el {
				.tit {
					padding-bottom: 5px;
					font-size: 14px;
					color: #333333;
				}

				.required::before {
					content: "*";
					color: red;
					margin-right: 2px;
				}
			}
		}
	}

	//主要内容
	.main_main {
		.page_main {
			padding: 18px 20px;

			.btn_el {
				margin: 10px 0 20px 0;

				.tips {
					padding: 6px 8px;
					background-color: #ffb1001a;
					border-radius: 6px;
					font-size: 16px;
					font-weight: bold;
				}
			}
		}

		//Header
		.page_header {
			padding: 0 20px;
			height: 60px;
			line-height: 60px;
			background-color: #d8e4f0;
			font-size: 24px;
			font-weight: bold;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
		}
	}
</style>
<style scoped>
	.main_box {
		height: calc(100vh - 60px);
		overflow-y: auto;
	}

	.main_box .main_main {
		position: relative;
		min-height: calc(100% - 0px);
		max-height: auto;
		background-color: #fafafa;
	}

	.el-header,
	.el-main {
		padding: 0;
	}

	.form-grid {
		display: grid;
		grid-template-columns: 1fr 1fr;
		column-gap: 28px;
		align-items: start;
	}

	.form-col {
		display: flex;
		flex-direction: column;
	}

	.full-width-item {
		margin-top: 8px;
	}

	/* label 样式 */
	::v-deep .el-form-item__label {
		padding-bottom: 8px;
		font-size: 14px;
		line-height: 20px;
		color: #2f343b;
		font-weight: 700;
	}

	/* 输入框统一风格 */
	.gray-input {
		background: #e9ecef;
		border: 1px solid #cfd5db;
		color: #2f343b;
		border-radius: 8px;
		padding-left: 15px;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
	}

	.text-tip {
		background-color: #fafafa;
		font-size: 20px;
		font-weight: 700;
		margin-bottom: 20px;
	}

	.required {
		color: #f56c6c;
		margin-left: 2px;
	}

	.tip-box {
		margin: 24px 0 16px;
		padding: 12px 8px;
		background: #fff7e8;
		border-radius: 4px;
		color: #222;
		font-weight: 600;
	}

	.file-panel {
		background: #fff;
		border: 1px solid #dcdfe6;
		margin-top: 40px;
	}

	.panel-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 12px 16px;
	}

	.table-title {
		font-size: 18px;
		font-weight: 700;
		color: #2f343b;
	}

	.search-input {
		width: 220px;
	}

	.file-table {
		width: 100%;
		margin-top: 8px;
	}

	.add-attachment-btn {
		margin: 10px;
	}

	.upload-doc-wrapper {
		width: 100%;
		margin-bottom: 40px;
		box-sizing: border-box;
	}

	.upload-title {
		font-size: 16px;
		color: #333;
		margin-bottom: 14px;
		font-weight: 500;
	}

	.required-title {
		position: relative;
		padding-left: 10px;
	}

	.required-title::before {
		content: "*";
		position: absolute;
		left: 0;
		top: 3px;
		color: #f56c6c;
		font-size: 15px;
	}

	.upload-limit {
		color: #666;
		font-weight: 400;
	}

	.upload-box {
		display: flex;
		align-items: center;
		width: 100%;
		height: 44px;
		border: 1px solid #dcdfe6;
		border-radius: 6px;
		overflow: hidden;
		background: #f5f7fa;
	}

	.doc-upload {
		flex-shrink: 0;
	}

	.file-name {
		flex: 1;
		height: 44px;
		line-height: 44px;
		padding: 0 16px;
		font-size: 15px;
		color: #333;
		background: #f5f7fa;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		position: relative;
	}

	.file-name.placeholder {
		color: #999;
	}

	.footer-actions {
		margin-top: 28px;
		text-align: center;
	}

	.footer-actions .el-button {
		padding: 7px 13px;
	}
</style>